module.exports = __webpack_public_path__ + "img/logo.71a46cc1.png";